export default __webpack_public_path__ + "static/media/Idle (7).9aaf9083.png";